import { indent as indent_1 } from './indent.locstring.json';
import loc from 'owa-localize';
import RibbonButton from './RibbonButton';

import { Indentation } from 'roosterjs-editor-types';
import { setIndentation } from 'roosterjs-editor-api';

const indent: RibbonButton = {
    key: 'indent',
    title: () => loc(indent_1),
    imageSrc: require('../svg/indent.svg'),
    imageRtlSrc: require('../svg/indent-rtl.svg'),
    onExecute: (plugin, logUsage) => {
        setIndentation(plugin.getEditor(), Indentation.Increase);
        logUsage('setIndentation', Indentation.Increase);
    },
};

export default indent;
